import script from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=8d8eb964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8eb964"]])

export default __exports__